module.exports = __webpack_public_path__ + "static/media/Trazado_9252_1_@2x.f8bd231c.png";